import React from 'react'
import FileUpload from '../components/FileUpload'
import AreaContent from '../components/AreaContent';
import AreaInfo from '../components/AreaInfo';
import AreaLogs from '../components/AreaLogs';
import Button from '../DMGComponents/Button';
import { getAreas, releaseArea, updateAreaName, updateAreaDescription } from '../fetchData';
import { withMsal } from "@azure/msal-react";
import ReactSpinner from 'react-bootstrap-spinner';
import UserManagement from '../components/UserManagement';
import AdHocUserManagement from '../components/AdHocUserManagement';
import PrivacyPolicy from '../components/PrivacyPolicy';
import { isDMGUser, isViableDMGUser } from '../authProvider';
import toast, { Toaster } from 'react-hot-toast';
import AreaTable from '../components/AreaTable';
import { getParameterByName } from '../utils/helperFunctions';
import FileExLogo from '../components/FileExLogo';
import EditableInput from '../components/EditableInput';
import AuthenticatedHeader from '../components/AuthenticatedHeader';
import { withRouter } from 'react-router-dom';

class FileEx extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            areas: [],
            tblData: [],
            selectedArea: null,
            loaded: false,
            moreShown: false,
        }
        this.areaSelected = this.areaSelected.bind(this);
    }

    componentDidMount() {
        const { history } = this.props;
        getAreas().then((res) => {
            let areaIdToSelect = null;
            let urlAreaIdParam = getParameterByName("areaId");
            if (urlAreaIdParam) {
                areaIdToSelect = parseInt(urlAreaIdParam);
            }
            if (this.props.location && this.props.location.state) {
                areaIdToSelect = this.props.location.state.areaId;
                if (this.props.location.state.areaCreated) {
                    toast.success("Area created.");
                }
                if (this.props.location.state.userCreated) {
                    toast.success("User created.");
                }
                history.replace();
            }
            let arr = []
            let arrTblData = []
            let areaToSelect = null;
            res.forEach(e => {
                arrTblData.push(this.fillAreaTblData(e));
                let arrToAdd = { displayName: e.name, data: e };
                arr.push(arrToAdd);
                if (areaIdToSelect && areaIdToSelect === e.id) {
                    areaToSelect = e;
                }
            });
            this.setState({
                areas: arr,
                tblData: arrTblData,
                loaded: true
            })
            if (areaToSelect != null) {
                this.areaSelected(areaToSelect);
            }
        }).catch((err) => {
            console.error("Error", err)
        })
    }

    showTable = () => {
        this.setState({
            selectedArea: null,
        });
    }

    releaseArea = () => {
        releaseArea(this.state.selectedArea.id).then(() => {
            this.setState(prevState => {
                let newSelectedArea = { ...prevState.selectedArea };
                newSelectedArea.status = 1;
                let newAreas = [...prevState.areas];
                let areaIndex = newAreas.findIndex((e) => e.data.id === newSelectedArea.id);
                if (areaIndex > -1) {
                    newAreas[areaIndex].data = newSelectedArea;
                }
                let newAreaTblData = []
                newAreas.forEach(e => {
                    newAreaTblData.push(this.fillAreaTblData(e.data));
                });
                return { selectedArea: newSelectedArea, areas: newAreas, tblData: newAreaTblData };
            })
        }).catch((err) => {
            console.error("Error", err)
        })
    }

    toggleShowMore = () => {
        let newState = !this.state.moreShown;
        this.setState({
            moreShown: newState,
        })
    }

    areaSelected = (selectedArea) => {
        if (selectedArea != null) {
            this.setState({
                selectedArea: selectedArea,
                moreShown: false,
            })
        }
    }

    areaIdSelected = (selectedAreaId) => {
        let areaIndex = this.state.areas.findIndex((e) => e.data.id === selectedAreaId);
        if (areaIndex > -1) {
            this.areaSelected(this.state.areas[areaIndex].data);
        }
    }

    fillAreaTblData = (area) => {
        return {
            id: area.id,
            name: area.name,
            creationTimeUnixMs: area.creationTimeUnixMs,
            expirationDateUnixMs: area.expirationDateUnixMs,
            description: area.description,
            areaSpace: area.areaSpace,
            usedSpace: area.usedSpace,
            status: area.status,
        };
    }

    removeArea = () => {
        this.setState(prevState => {
            let selectedAreaId = prevState.selectedArea.id;
            let newAreas = [...prevState.areas];
            let areaIndex = newAreas.findIndex((e) => e.data.id === selectedAreaId);
            if (areaIndex > -1) {
                newAreas.splice(areaIndex, 1);
            }
            let newAreaTblData = []
            newAreas.forEach(e => {
                newAreaTblData.push(this.fillAreaTblData(e.data));
            });
            return { selectedArea: null, areas: newAreas, tblData: newAreaTblData };
        })
        toast.success("Area deleted.");
    }

    updateAreaExpiration = (newExpirationDate) => {
        this.setState(prevState => {
            let newSelectedArea = { ...prevState.selectedArea };
            newSelectedArea.expirationDateUnixMs = newExpirationDate;
            let newAreas = [...prevState.areas];
            let areaIndex = newAreas.findIndex((e) => e.data.id === newSelectedArea.id);
            if (areaIndex > -1) {
                newAreas[areaIndex].data = newSelectedArea;
            }
            let newAreaTblData = []
            newAreas.forEach(e => {
                newAreaTblData.push(this.fillAreaTblData(e.data));
            });
            return { selectedArea: newSelectedArea, areas: newAreas, tblData: newAreaTblData };
        })
    }

    updateAreaUsedSpace = (overallSizeInBytes) => {
        this.setState(prevState => {
            let newSelectedArea = { ...prevState.selectedArea };
            newSelectedArea.usedSpace = overallSizeInBytes;
            let newAreas = [...prevState.areas];
            let areaIndex = newAreas.findIndex((e) => e.data.id === newSelectedArea.id);
            if (areaIndex > -1) {
                newAreas[areaIndex].data = newSelectedArea;
            }
            let newAreaTblData = []
            newAreas.forEach(e => {
                newAreaTblData.push(this.fillAreaTblData(e.data));
            });
            return { selectedArea: newSelectedArea, areas: newAreas, tblData: newAreaTblData };
        })
    }

    updateAreaSettings = (areaUpgradeInfo) => {
        this.setState(prevState => {
            let newSelectedArea = { ...prevState.selectedArea };
            newSelectedArea.areaSpace = areaUpgradeInfo.areaSpace;
            newSelectedArea.fileSpace = areaUpgradeInfo.fileSpace;
            newSelectedArea.expirationDateUnixMs = areaUpgradeInfo.expirationDateUnixMs;
            let newAreas = [...prevState.areas];
            let areaIndex = newAreas.findIndex((e) => e.data.id === newSelectedArea.id);
            if (areaIndex > -1) {
                newAreas[areaIndex].data = newSelectedArea;
            }
            let newAreaTblData = []
            newAreas.forEach(e => {
                newAreaTblData.push(this.fillAreaTblData(e.data));
            });
            return { selectedArea: newSelectedArea, areas: newAreas, tblData: newAreaTblData };
        })
    }

    setAreaAccessEntryTrue = () => {
        this.setState(prevState => {
            let newSelectedArea = { ...prevState.selectedArea };
            newSelectedArea.accessEntry = true;
            let newAreas = [...prevState.areas];
            let areaIndex = newAreas.findIndex((e) => e.data.id === newSelectedArea.id);
            if (areaIndex > -1) {
                newAreas[areaIndex].data = newSelectedArea;
            }
            return { selectedArea: newSelectedArea, areas: newAreas };
        })
    }

    saveNewAreaName = (newAreaName) => {
        updateAreaName(this.state.selectedArea.id, newAreaName).then(() => {
            this.setState(prevState => {
                let newSelectedArea = { ...prevState.selectedArea };
                newSelectedArea.name = newAreaName;
                let newAreas = [...prevState.areas];
                let areaIndex = newAreas.findIndex((e) => e.data.id === newSelectedArea.id);
                if (areaIndex > -1) {
                    newAreas[areaIndex].data = newSelectedArea;
                }
                let newAreaTblData = []
                newAreas.forEach(e => {
                    newAreaTblData.push(this.fillAreaTblData(e.data));
                });
                return { selectedArea: newSelectedArea, areas: newAreas, tblData: newAreaTblData };
            })
            toast.success("Area name updated.");
        }).catch((err) => {
            toast.error("Error saving new area name.");
        })
    }

    saveNewAreaDescription = (newAreaDescription) => {
        updateAreaDescription(this.state.selectedArea.id, newAreaDescription).then(() => {
            this.setState(prevState => {
                let newSelectedArea = { ...prevState.selectedArea };
                newSelectedArea.description = newAreaDescription;
                let newAreas = [...prevState.areas];
                let areaIndex = newAreas.findIndex((e) => e.data.id === newSelectedArea.id);
                if (areaIndex > -1) {
                    newAreas[areaIndex].data = newSelectedArea;
                }
                let newAreaTblData = []
                newAreas.forEach(e => {
                    newAreaTblData.push(this.fillAreaTblData(e.data));
                });
                return { selectedArea: newSelectedArea, areas: newAreas, tblData: newAreaTblData };
            })
            toast.success("Area description updated.");
        }).catch((err) => {
            toast.error("Error saving new area description.");
        })
    }

    render() {
        const areaTblData = { nodes: this.state.tblData };
        return (
            <div>
                <Toaster />
                <div>
                    <AuthenticatedHeader />
                    {!isViableDMGUser()
                        ?
                        (<div style={{ flex: '1' }}>
                            <FileExLogo />
                            <p>Please login with a <i>my</i> DMG MORI account.</p>
                        </div>)
                        :
                        !this.props.accessChecked
                            ?
                            (<div style={{ flex: '1' }}>
                                <FileExLogo />
                                <p>Checking permissions...</p>
                            </div>)
                            :
                            this.props.userAllowed
                                ?
                                <React.Fragment>
                                    <FileExLogo clicked={() => { this.showTable() }} />
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {!this.state.loaded ?
                                            <div style={{ flex: '1' }}>
                                                <ReactSpinner type="border" color="black" size="3" />
                                            </div>
                                            :
                                            <div style={{ display: 'flex', flex: '1', alignItems: 'center', justifyContent: 'center' }}>
                                                {this.state.areas.length != 0 && this.state.selectedArea === null &&
                                                    <div style={{ flex: '1' }}>
                                                        {this.state.selectedArea == null &&
                                                            <span>Please select an area from below.</span>
                                                        }
                                                    </div>
                                                }
                                                {this.state.areas.length != 0 && this.state.selectedArea != null &&
                                                    <div style={{ flex: '1', justifyContent: "left", paddingRight: "6px" }}>
                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                            <div style={{ display: "flex", textAlign: "left", alignItems: "center" }}>
                                                                Selected area:{'\u00A0'}<EditableInput value={this.state.selectedArea.name} save={(newAreaName) => this.saveNewAreaName(newAreaName)} minLength={1} />
                                                            </div>
                                                            <div style={{ display: "flex", textAlign: "left" }}>
                                                                Description:{'\u00A0'}<EditableInput value={this.state.selectedArea.description} save={(newDescription) => this.saveNewAreaDescription(newDescription)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                {this.state.areas.length != 0 && this.state.selectedArea != null && this.state.selectedArea.status === 0 &&
                                                    <div style={{ display: "flex", justifyContent: "right", marginRight: '12px' }}>
                                                        <Button type="hover-bottom-left" onClick={() => { this.releaseArea() }}>Release</Button>
                                                    </div>
                                                }
                                                {this.state.areas.length != 0 && this.state.selectedArea != null &&
                                                    <div style={{ display: "flex", justifyContent: "right" }}>
                                                        <Button type="hover-bottom-left" onClick={() => { this.showTable() }}>Show areas list</Button>
                                                    </div>
                                                }
                                                {isDMGUser() && this.state.areas.length != 0 &&
                                                    <div style={{ flex: '0 0 auto', marginLeft: '12px' }}>
                                                        <Button type="hover-bottom-left" onClick={() => this.props.history.push('/createArea')}>New Area</Button>
                                                    </div>
                                                }
                                                {isDMGUser() && this.state.areas.length == 0 &&
                                                    <div style={{ flex: '0 0 auto', marginLeft: 'auto' }}>
                                                        <Button type="hover-bottom-left" onClick={() => this.props.history.push('/createArea')}>New Area</Button>
                                                    </div>
                                                }
                                                {!isDMGUser() && this.state.areas.length === 0 &&
                                                    <div style={{ flex: '0 0 auto' }}>
                                                        No one currently shared any files with you.
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                    {this.state.areas.length != 0 && this.state.selectedArea === null &&
                                        <div style={{ flex: '1', marginTop: '12px' }}>
                                            <AreaTable data={areaTblData} clickedIdChange={this.areaIdSelected} />
                                        </div>
                                    }
                                    {this.state.selectedArea != null &&
                                        <div>
                                            {this.state.selectedArea.accessEntry ?
                                                <div>
                                                    <AreaContent area={this.state.selectedArea} refreshAreaContent={refreshMethod => this.refreshAreaContent = refreshMethod} updateAreaUsedSpace={this.updateAreaUsedSpace} />
                                                    {this.state.selectedArea.allowWrite &&
                                                        <FileUpload areaId={this.state.selectedArea?.id} appWidth={this.props.appWidth} refreshAreaContent={() => this.refreshAreaContent()}
                                                        maxFileSize={this.state.selectedArea.fileSpace} areaStatus={this.state.selectedArea?.status} isAdHoc={this.state.selectedArea?.isAdHoc} />
                                                    }
                                                    {this.state.selectedArea.isOwner && this.state.selectedArea.isAdHoc &&
                                                        <AdHocUserManagement areaId={this.state.selectedArea?.id} areaStatus={this.state.selectedArea?.status} />
                                                    }
                                                    {this.state.selectedArea.isOwner && !this.state.selectedArea.isAdHoc &&
                                                        <UserManagement areaId={this.state.selectedArea?.id} areaStatus={this.state.selectedArea?.status} />
                                                    }
                                                    {this.state.moreShown &&
                                                        <div>
                                                            <AreaInfo area={this.state.selectedArea} updateAreaExpiration={this.updateAreaExpiration} removeArea={this.removeArea} updateAreaSettings={this.updateAreaSettings}
                                                                isAdHoc={this.state.selectedArea.isAdHoc} />
                                                            {this.state.selectedArea.isOwner &&
                                                                <AreaLogs area={this.state.selectedArea} />
                                                            }
                                                            <div style={{ display: "flex", justifyContent: "right", marginBottom: "4px" }}>
                                                                <Button type="hover-bottom-left" onClick={() => this.toggleShowMore()}>Show less</Button>
                                                            </div>
                                                        </div>
                                                    }
                                                    {!this.state.moreShown &&
                                                        <div style={{ display: "flex", justifyContent: "right", marginBottom: "4px" }}>
                                                            <Button type="hover-bottom-left" onClick={() => this.toggleShowMore()}>Show more</Button>
                                                        </div>
                                                    }
                                                </div>
                                                :
                                                <div>
                                                    <PrivacyPolicy area={this.state.selectedArea} agreeToPrivacyPolicy={this.setAreaAccessEntryTrue} />
                                                </div>
                                            }
                                        </div>
                                    }
                                </React.Fragment>
                                :
                                <div style={{ flex: '1' }}>
                                    <FileExLogo />
                                    <p>Forbidden.</p>
                                </div>
                    }
                </div>
            </div>
        );
    }
}
const firstHOC = withRouter(FileEx);
export default FileEx = withMsal(withRouter(firstHOC));